import React, { useState, useEffect } from 'react'
import Renderer from './Renderer'
import { Store, initStore } from '@polystack/admin/src/store/store'
import { initUiStore } from '@polystack/admin/src/store/uistore'
import NoSSR from '@polystack/admin/src/utils/no-ssr'
import { observer } from 'mobx-react'
import { Loading } from '@polystack/admin/src/components/LoadingLogo'
import { CSSTransition } from 'react-transition-group'
import { ComponentProvider } from '@polystack/admin/src/utils/renderer/Context'
import DataSourceFactory from '@polystack/admin/src/store/models/datasource-factory'
import { StoreContext } from '@polystack/admin/src/hooks/use-store'

if(typeof window !== 'undefined') {
  window.Store = Store
  window.is_pls_client = true
}

const App = observer((props) => {
  const { markup, loading = true, user, env = {} } = props || {}
  const environment = { user, ...env, ro: true }
  const [ store, setStore ] = useState(props.store && initStore(props.store, environment))
  const [ uistore ] = useState(initUiStore())
  const [ isLoading, setIsLoading ] = useState(loading)

  if (store?.currentApp && uistore && typeof window !== 'undefined' && !uistore.dataSourceFactory) {
    uistore.setDataSourceFactory(new DataSourceFactory(store.currentApp))
  }

  let settings = props.settings
  if(typeof window !== 'undefined') {
    settings = window.__polystack_data__
  }
  const ass = settings?.assignmentVersionId || store?.assignmentVersionId
  const timeout = settings?.loadingTransitionTimeout || 300
  
  useEffect(() => {
    if(!props.store) {
      (async () => {
        let result = await fetch(`/_build/assignment/${ass}.json`).then(j => j.json())
        if(result) setStore(initStore(result, {...environment, ...result.env || {}}))
        setIsLoading(false)
      })()
    }
  }, [props.store])
  
  const item = store?.currentApp.assignment
  return (
    <div className='assignment-preview'>
      <CSSTransition
        classNames={{ exit: 'animate__animated', exitActive: 'animate__fadeOut'}}
        in={!!(isLoading && settings)}
        timeout={timeout}
        unmountOnExit
      >
        <div style={{ display: 'flex', width: '100vw', height: '100vh' }}>
	  <Loading store={{settings}} />
        </div>
      </CSSTransition>
      {!isLoading && (
        <StoreContext.Provider value={{store, uistore}}>
          <ComponentProvider routes={item?.navigation?.routes}>
            <Renderer
              location={props.location}
	      store={store}
              {...item}
            />
          </ComponentProvider>
        </StoreContext.Provider>
      )}

    </div>
  )
})

export default App
